import axios from "axios";
import * as actionType from "../actionTypes";
import apiConstants from "../../constans/apiConstants";
import { toaster } from "../../utils/utils";

// main

const showToastWithDelay = (message) => {
  toaster("error", message);
  setTimeout(() => {
      // toaster(""); 
  }, 5000);
};

export const getPSMaction = (cb) => { 
  return (dispatch) => {
    dispatch({ type: actionType.LOADER_TRUE });
    axios
      .get(
        `${apiConstants().PROPOSEL_API_URL}api/v1/proposal/ops/psm-matrix`,
        {
          headers: {
            "Content-Type": "application/json",
            authorization: localStorage.getItem("token"),
          },
        }
      )
      .then((res) => {  
        dispatch({ type: actionType.LOADER_FALSE });
      
      if(res.data.status !=='BAD_REQUEST'){
        if (res.data.body) {
          // toaster("success", res.data.message);
          if (res.data) {
            cb(res.data);
          }
        } else {
          toaster("error", res.data.message);
        }
      }
      else {
          showToastWithDelay(res.data.message); 
          if (res.data) {
            cb(res.data);
          }
      }
      })
      .catch(() => {
        dispatch({ type: actionType.LOADER_FALSE });
      });
  };
};

//add
export const psmPoposal = (data, cb) => { 
  return (dispatch) => {
    dispatch({ type: actionType.LOADER_TRUE });
    axios
      .post(
        `${apiConstants().PROPOSEL_API_URL}api/v1/proposal/ops/psm-matrix`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
            authorization: localStorage.getItem("token"),
          },
        }
      )
      .then((res) => {   
        dispatch({ type: actionType.LOADER_FALSE });
      
      if(res.data.status !=='BAD_REQUEST'){ 
        if (res.data.body) {
          toaster("success", res.data.message);
          if (res.data) {
            cb(res.data);
          }
        } else {
          toaster("error", res.data.message);
        }
      }
      else {
          showToastWithDelay(res.data.message); 
      }
      })
      .catch(() => {
        dispatch({ type: actionType.LOADER_FALSE });
      });
  };
};

// delete
export const psmDeletePoposal = (data, cb) => async (dispatch) => {
  const deleteDataId = data.id;
  try {
    dispatch({ type: actionType.LOADER_TRUE });

    const res = await axios
    
      .delete(
        `${
          apiConstants().PROPOSEL_API_URL
        }api/v1/proposal/ops/psm-matrix/${deleteDataId}`,
        {
          headers: {
            Authorization: localStorage.getItem("token"),
          },
        }
      )
      .then((res) => {
        dispatch({ type: actionType.LOADER_FALSE })

        if (res && res.data.status === "OK") {
          toaster("success", res.data.message);
        } else {
          toaster("error", res.data.message);
        }
        if (cb) {
          cb(res);
        }
      });
  } catch (err) {
    dispatch({ type: actionType.LOADER_FALSE })
    console.log(`err`, err);
  }
};

export const getPSMLogs = (payload) => {
  return async (dispatch) => {
    dispatch({ type: "LOADER_TRUE" });
    const { page = 0, size = 10, searchKey = "", date = '' } = payload;
    const url = `${apiConstants().BAXA_API_URL}psm/logs?page=${page}&size=${size}&searchKey=${searchKey}&date=${date ? date : ''}`;
    try {
      const res = await axios.get(
        url,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: localStorage.getItem("token"),
          },
        },
      );

      dispatch({ type: "LOADER_FALSE" });
      if (res && res.data) {
        return res?.data;
      }
    } catch (err) {
      dispatch({ type: "LOADER_FALSE" });

      if (err?.response?.data?.message) {
        toaster("error", err.response.data.message);
      } else {
        toaster("error", "Something went wrong");
      }
    }
  };
};

export const downloadPSMLogs = (payload) => {
  return async (dispatch) => {
    dispatch({ type: "LOADER_TRUE" });

    try {
      const path = `${apiConstants().BAXA_API_URL}download/${payload?.proposalNumber}?file=${payload?.fileName}&folderType=${payload.folderType}`;

      const res = await axios.get(path, {
        headers: {
          "Content-Type": "application/json",
          Authorization: localStorage.getItem("token"),
        },
      });

      dispatch({ type: "LOADER_FALSE" });

      if (res && res.data) {
        const response = res.data;

        // Prepare file data
        const fileData = JSON.stringify(response, null, 4);

        // Create download link
        const a = document.createElement("a");
        a.href = URL.createObjectURL(
          new Blob([fileData], { type: "application/json" })
        );

        a.download = `${response.action || "PSM_Log"}.json`;
        a.click();

        toaster("success", "File downloaded successfully");
      }
    } catch (err) {
      dispatch({ type: "LOADER_FALSE" });

      if (err?.response?.data?.message) {
        toaster("error", err.response.data.message);
      } else {
        toaster("error", "Something went wrong");
      }
    }
  };
};
